module.exports = __webpack_public_path__ + "sy.svg?fce5d4b9abdc1893f95cffc4eabd39da";